import React, { useContext } from "react";
import BasketRadio from "./forms/BasketRadio";
import { change, Field, formValueSelector, reduxForm } from "redux-form";
import { connect } from "react-redux";
// import DatePicker from "../DatePicker/DatePicker";
import { requiredField } from "../Calc/validators/validators";
import { Input } from "../Calc/forms/FormControls";
import { TextContext } from "../../context/TextContext";
// import { setDeliveryDate } from "../../redux/Calc_reducer";

let BasketForm = props => {
    const {data} = useContext(TextContext)
    const resetForm = (fields) => {
        Object.keys(fields).forEach(field => props.dispatch(change("basketDelivery", field, fields[field])));
    }
    return <form onSubmit={props.handleSubmit}>
        <div className="bl_4_grid_item basketDelivery">
            <div className="calc_title_box">
                <div className="calc_title">Способ доставки</div>
                <BasketRadio func={() => resetForm({deliveryAddress: null})} name={"delivery"} id={"delivery1"}
                             value={"Самовывоз"}
                             txt={`Самовывоз (${data.address ?? "г. Москва, Дмитровское шоссе, 102Ас4"})`}/>
                <BasketRadio name={"delivery"} id={"delivery2"} value={"МСК"} txt={"Доставка в пределах МКАД"}/>
                {props.hasDelivery === "МСК" &&
                    <Field style={{width: "80%", margin: "1vh auto"}} className="calc_input_form"
                           validate={[requiredField]}
                           step={"10"} min={"150"} component={Input}
                           placeholder={"Ивановская улица, 47к1"}
                           name={"deliveryAddress"} type={"text"}/>}
                <BasketRadio name={"delivery"} id={"delivery3"} value={"МКАД"}
                             txt={"Доставка за МКАД (детали уточняются при звонке)"}/>
                {props.hasDelivery === "МКАД" &&
                    <Field style={{width: "80%", margin: "1vh auto"}} className="calc_input_form"
                           validate={[requiredField]}
                           step={"10"} min={"150"} component={Input}
                           placeholder={"Ивановская улица, 47к1"}
                           name={"deliveryAddress"} type={"text"}/>}
            </div>
        </div>
        <div className="bl_4_grid_item basketDelivery" style={{marginTop: 10}}>
            <div className="calc_title_box">
                <div className="calc_title">Комментарий для менеджера</div>
                <Field style={{width: "80%", height:100,margin: "1vh auto"}} className="calc_input_form"
                       validate={[requiredField]}
                       component={"textarea"}
                       name={"comment"} type={"text"}/>
            </div>
        </div>
        {/*<DatePicker setDeliveryDate={props.setDeliveryDate}/>*/}
    </form>
}

BasketForm = reduxForm({
    form: "basketDelivery"
})(BasketForm)
const selector = formValueSelector("basketDelivery");
export default BasketForm = connect(state => ({
    hasDelivery: selector(state, "delivery"),
    hasDeliveryAddress: selector(state, "deliveryAddress"),
    hasComment: selector(state, "comment")
}), {/*setDeliveryDate*/})(BasketForm)
